import config from '../config/config';

export function token() {
  const token_value = localStorage.getItem('tokenv2');
  if (!token_value) return '';
  return 'Token ' + token_value;
}

export async function handleResponse(response) {
  if (response.status === 204) return {};
  if (response.ok) return response.json();
  if (response.status === 400) {
    const error = await response.text();
    throw new Error(error);
  }
  if (response.status === 404) {
    //const error = await response.text();

    throw new Error('Chargemix Not Found');
  }
  if (response.status === 401) {
    localStorage.clear();
    window.location = '/login';
  }
  throw new Error('Network Response was not Ok');
}

export function handleError(error) {
  // eslint-disable-next-line no-console
  console.error('API call failed. ' + error);
  throw error;
}

export function cFetch(baseUrl, headers = {}) {
  return fetch(baseUrl, headers).then(handleResponse).catch(handleError);
}

/**
 * Generic function to get API options for any endpoint
 * @param {string} endpoint - API endpoint path (e.g., '/api/c/grades_add_api/')
 * @returns {Promise<object>} - JSON object containing options data
 */
export const getApiOptions = async (endpoint) => {
  try {
    const headers = {
      method: 'OPTIONS',
      headers: {
        authorization: token(),
        'Content-Type': 'application/json'
      }
    };

    const data = await cFetch(`${config.API_URL}${endpoint}`, headers);
    return data;
  } catch (error) {
    throw new Error(`Failed to fetch API options for ${endpoint}: ${error.message}`);
  }
};

/**
 * Check if a field exists in API options
 * @param {object} apiOptions - API options object
 * @param {string} fieldName - Field name to check
 * @param {string} action - Action type (default: 'POST')
 * @returns {boolean} - Whether the field exists
 */
export const hasField = (apiOptions, fieldName, action = 'POST') => {
  return apiOptions?.actions?.[action]?.[fieldName] !== undefined;
};

/**
 * Check if multiple fields exist in API options
 * @param {object} apiOptions - API options object
 * @param {string[]} fieldNames - Array of field names to check
 * @param {string} action - Action type (default: 'POST')
 * @returns {boolean} - Whether all fields exist
 */
export const hasFields = (apiOptions, fieldNames, action = 'POST') => {
  return fieldNames.every(fieldName => hasField(apiOptions, fieldName, action));
};

/**
 * Get field configuration from API options
 * @param {object} apiOptions - API options object
 * @param {string} fieldName - Field name to get config for
 * @param {string} action - Action type (default: 'POST')
 * @returns {object|null} - Field configuration or null if not found
 */
export const getFieldConfig = (apiOptions, fieldName, action = 'POST') => {
  return apiOptions?.actions?.[action]?.[fieldName] || null;
};

/**
 * Get available fields from API options
 * @param {object} apiOptions - API options object
 * @param {string} action - Action type (default: 'POST')
 * @returns {string[]} - Array of available field names
 */
export const getAvailableFields = (apiOptions, action = 'POST') => {
  return Object.keys(apiOptions?.actions?.[action] || {});
};
